import { Config } from '.';

const config: Config = {
    API_URL: '',
};

export default config;
